module.exports = __webpack_public_path__ + "files/0c0d9fbd89efb55e89c1f7cee0d1b7f8.png";